import fetchAPI from 'utils/fetchAPI';

export const ERR_NO_REFERRAL_CODE = 'ERR_NO_REFERRAL_CODE';
export const ERR_NO_PHONE_NUMBER_INPUT = 'ERR_NO_PHONE_NUMBER_INPUT';

export function fetchReferrer(referralCode) {
  return new Promise((resolve, reject) => {
    if (!referralCode) {
      reject(ERR_NO_REFERRAL_CODE);
      return;
    }

    fetchAPI({
      method: 'GET',
      endpoint: `/user/referral_code/${referralCode}`,
    })
      .then(res => res.json())
      .then(json => {
        if (json.error_code) {
          return reject(json);
        }
        return resolve(json);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function checkReferral(
  referralCode,
  countryCode,
  rawPhoneNumber,
  referreeName
) {
  return new Promise((resolve, reject) => {
    if (!rawPhoneNumber) {
      reject(ERR_NO_PHONE_NUMBER_INPUT);
      return;
    }

    const refereePhoneNumber = countryCode + rawPhoneNumber;

    fetchAPI({
      method: 'POST',
      endpoint: '/users/referral_check',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        referral_code: referralCode,
        phone_number: refereePhoneNumber,
        full_name: referreeName,
      }),
    })
      .then(res => {
        if (res.status === 200) {
          return resolve();
        }
        return res.json();
      })
      .then(err => {
        reject(err);
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./app/actions/referral/index.js